module.exports = __webpack_public_path__ + "img/product2.706c5581.png";